var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.198,
    height: 18,
    viewBox: "0 0 19.198 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-userlist",
    transform: "translate(-4.76 -5.359)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2227",
    "data-name": "Rectangle 2227",
    width: 18,
    height: 18,
    transform: "translate(5.359 5.359)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6783",
    "data-name": "Path 6783",
    d: "M-5705.829-1943.532a13.671,13.671,0,0,1-4.523.551c-3.359,0-4.564-.572-4.772-.687a1,1,0,0,1-.516-.875,5.461,5.461,0,0,1,1.33-3.271,5.471,5.471,0,0,1,1.53-1.283,3.891,3.891,0,0,1-1.455-3.035,3.9,3.9,0,0,1,3.895-3.9,3.9,3.9,0,0,1,3.9,3.9,3.89,3.89,0,0,1-1.46,3.038,5.6,5.6,0,0,1,1.538,1.271,6.269,6.269,0,0,1,.517.7,6.185,6.185,0,0,1,.463-.673,5.309,5.309,0,0,1,1.424-1.268,3.891,3.891,0,0,1-1.5-3.068,3.9,3.9,0,0,1,3.9-3.9,3.9,3.9,0,0,1,3.9,3.9,3.891,3.891,0,0,1-1.5,3.071,5.425,5.425,0,0,1,1.433,1.258,5.555,5.555,0,0,1,1.294,3.259,1,1,0,0,1-.519.876c-.209.115-1.415.686-4.613.686A12.155,12.155,0,0,1-5705.829-1943.532Zm1.306-1.7a14.14,14.14,0,0,0,2.948.251,14.462,14.462,0,0,0,3-.257,3.414,3.414,0,0,0-3-2.492A3.323,3.323,0,0,0-5704.522-1945.231Zm-8.985-.009a15.57,15.57,0,0,0,3.156.26,16.064,16.064,0,0,0,3.209-.264,3.6,3.6,0,0,0-3.209-2.484A3.493,3.493,0,0,0-5713.508-1945.24Zm10.047-6.891a1.9,1.9,0,0,0,1.9,1.9,1.9,1.9,0,0,0,1.9-1.9,1.9,1.9,0,0,0-1.9-1.9A1.9,1.9,0,0,0-5703.461-1952.131Zm-8.776,0a1.9,1.9,0,0,0,1.9,1.9,1.9,1.9,0,0,0,1.9-1.9,1.9,1.9,0,0,0-1.9-1.9A1.9,1.9,0,0,0-5712.237-1952.131Z",
    transform: "translate(5720.401 1964.287)",
    fill: "#222a41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserlist);
export default __webpack_public_path__ + "static/media/icon_userlist.7898a40c.svg";
export { ForwardRef as ReactComponent };